import { MarkdownOptions, createMarkdownRenderer } from './markdown';

const options: MarkdownOptions = {};

const md = createMarkdownRenderer(options);

export default md;
